import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getDimensionOptions } from './getDimensionOptions'
import { Dimension } from '../types/Dimension'

export const useCtxDimensions = <TData = Dimension[]>(select?: (data: Dimension[]) => TData) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = getDimensionOptions(companyId, select)
  return useQuery(options)
}
